import * as t from 'constants/ActionTypes.js';
import { ROOT_URL } from 'constants/Config.js';
import { createAction } from 'redux-actions';
import { getRegionsForDisplay } from 'utils/regionStorage';

import axios from 'axios';

export const forcedSearchChange = createAction(t.FORCED_SEARCH_CHANGE);

// export const changeFilters = createAction(t.CHANGE_FILTERS);

function _changeFilters(filters, options = {}) {
  // const { costMin, costMax, priceMin, priceMax, areaFrom, areaTo, hasFilters } = filters || {};
  // const meta = filters && !hasFilters && (costMin || costMax || priceMin || priceMax || areaFrom || areaTo) ?
  // {
  //   meta: {
  //     debounce: {
  //       time: 1000
  //     }
  //   }
  // } : {};
  return {
    type: t.CHANGE_FILTERS,
    payload: filters,
    reset: options.reset || false,
    withoutTypeFilters: options.withoutTypeFilters || false,
    // ...meta
  };
}

export const changeFilters = (filters, options) => (dispatch) => {
  // FIXME: вынести это отсюда, сделать всю страницу с новострйоками в виде контенеров
  // вью
  if (window.location.pathname.includes('cottages')) {
    dispatch(_changeFilters({ ...filters, typeId: 2 }, options));
  } else if (window.location.pathname.includes('building')) {
    dispatch(_changeFilters({ ...filters, typeId: 1 }, options));
  } else {
    dispatch(_changeFilters(filters, options));
  }
};

// export const changeFocus = createAction(t.CHANGE_FOCUS);

// export const autocomplete = createAction(t.LOAD_AUTOCOMPLETE, async (query) => {
//   const response = await axios.get(`${ROOT_URL}/buildings/autocomplete?query=${encodeURIComponent(query)}`);
//   return response.data;
// });

// FIXME: make it work with redux promise middlware

// export function autocomplete(query) {
//   return (dispatch) => {
//     dispatch({ type: t.LOAD_AUTOCOMPLETE_FETCHING });
//     return axios
//       .get(`${ROOT_URL}/buildings/autocomplete?query=${encodeURIComponent(query)}`)
//       .then((response) => {
//         dispatch({ type: t.LOAD_AUTOCOMPLETE_SUCCESS, payload: response.data });
//       })
//       .catch((error) => {
//         dispatch({ type: t.LOAD_AUTOCOMPLETE_ERROR, payload: error });
//       });
//   };
// }

export function quicksearch(query, region) {
  return (dispatch) => {
    dispatch({ type: t.LOAD_QUICKSEARCH_FETCHING });
    return axios
      .post(`${ROOT_URL}/buildings/quicksearch`, {
        query,
        region,
      })
      .then((response) => {
        dispatch({ type: t.LOAD_QUICKSEARCH_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: t.LOAD_QUICKSEARCH_ERROR, payload: error });
      });
  };
}

const _setSearchValue = createAction(t.SET_SEARCH_VALUE);

export const setSearchValue = (value) => (dispatch, getState) => {
  dispatch(_setSearchValue(value));
  if (value) {
    const state = getState();
    const cities = state.building.cities || [];

    const { user_regions: userRegions } = getRegionsForDisplay(cities);

    // Собираем ID всех регионов (areas) из выбранных городов
    const regionIds = [];
    if (userRegions && userRegions.length > 0) {
      userRegions.forEach((region) => {
        const city = cities.find(
          (c) => c.name === region.city && c.country && c.country.id === region.country_id
        );
        if (city && city.areas) {
          city.areas.forEach((area) => {
            if (area.id) {
              regionIds.push(area.id);
            }
          });
        }
      });
    }

    dispatch(quicksearch(value, regionIds));
  }
};

export const setSearchModalState = createAction(t.SET_SEARCH_MODAL_STATE);



// WEBPACK FOOTER //
// ./src/actions/search.js